export default __webpack_public_path__ + "static/media/lenovo-laptop.fce85017.png";